// src/content/contact.js
// نصوص وقيم قسم الاتصال (JS - RTL)

export const contactContent = {
  sectionId: "contact",

  header: {
    // لو عندك SectionHeader جاهز يقرأ من headers.contact، اتركه كما هو
    // وهنا نكتفي بنصوص داخل الورقة فقط
  },

  form: {
    title: "أرسل رسالة",
    labels: {
      name: "الاسم الكامل",
      phone: "رقم الجوال",
      company: "اسم المنشأة (اختياري)",
      message: "نص الرسالة",
    },
    ctaWhatsapp: "إرسال عبر واتساب",
    min: {
      name: 2,
      phone: 8,
      message: 5,
    },
  },

  info: {
    title: "معلومات الاتصال",
    hours: "أوقات العمل:  9:00 ص – 9:00 م",
    location: "خميس مشيط - سوق الكمبيوتر",
    chips: ["دعم عربي", "تدريب مجاني", "تهيئة سريعة"],
  },
};
